export const CREATE_CONVERSATION = 'CONVERSATION/CREATE';
export const LOAD_CONVERSATIONS = 'CONVERSATION/LOAD';
export const ADD_MESSAGE = 'CONVERSATION/ADD_MESSAGE';
export const ADD_MESSAGE_TO_DB = 'CONVERSATION/ADD_MESSAGE_TO_DB';
export const LOADING_STATUS = 'CONVERSATION/LOADING_STATUS';
